import React from "react";
import { ChevronLeft as ChevronLeftIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CustomCircleIconButton } from "@ippon/shared-components";

interface BackButtonProps {
  /** 置き場所で占める幅・高さ(px)。ホバーの円はこの外側へ 4px ずつはみ出す。 */
  size?: number;
  /** 省略時は navigate(-1) で1つ前のページへ。 */
  onClick?: () => void;
  ariaLabel?: string;
}

// ホバーの円を、見出しの行の高さを変えずに外側へはみ出させる幅。
const CIRCLE_BLEED = 4;

/**
 * セクションタイトル左に置く「戻る」ボタン。
 * 「‹」アイコンで、通常は枠線・背景なし・ホバーで青の円の枠線と薄い青の背景・押下で軽く縮む。クリックで1つ前へ。
 */
export const BackButton: React.FC<BackButtonProps> = ({
  size = 24,
  onClick,
  ariaLabel = "前のページに戻る",
}) => {
  const navigate = useNavigate();
  return (
    <CustomCircleIconButton
      ariaLabel={ariaLabel}
      onClick={onClick ?? (() => navigate(-1))}
      size={size + CIRCLE_BLEED * 2}
      sx={{ m: `-${CIRCLE_BLEED}px` }}
    >
      {/* 「‹」は「←」より細く小さく見えるため、円の内側いっぱいまで大きくする。 */}
      <ChevronLeftIcon sx={{ fontSize: size + CIRCLE_BLEED }} />
    </CustomCircleIconButton>
  );
};

export default BackButton;
